<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
              <div class="col-lg-6 col-md-8 ml-auto mr-auto">
                  <card type="login">
                    <h4 slot="header" class="header text-center"><translate>Registration</translate></h4>
                    <p class="text-danger text-center">
                      {{ errorMessage }}
                    </p>
                    <p v-if="loading && invitation === null" class="text-center"><translate>Checking invitation key. Please wait...</translate></p>
                    <form @submit.prevent="validateBeforeSubmit" autocomplete="on" v-if="invitation !== null">
                        <div class="row">
                          <div class="col-md-4">
                            <fg-input name="family-name" v-model="form.lastName" autocomplete="section-registration family-name" :placeholder="'Last name' | translate" :label="'Last name' | translate" :error="errorsMessages.lastName"></fg-input>
                          </div>
                          <div class="col-md-4">
                            <fg-input name="given-name" v-model="form.firstName" autocomplete="section-registration given-name" :placeholder="'First name' | translate" :label="'First name' | translate" :error="errorsMessages.firstName"></fg-input>
                          </div>
                          <div class="col-md-4">
                            <fg-input name="additional-name" v-model="form.secondName" autocomplete="section-registration additional-name" :placeholder="'Second name' | translate" :label="'Second name' | translate" :error="errorsMessages.secondName"></fg-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <fg-input name="username" v-model="form.username" autocomplete="section-registration username" addon-left-icon="nc-icon nc-single-02" :placeholder="'Username' | translate"  :error="errorsMessages.username"></fg-input>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group input-group">
                              <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="nc-icon nc-email-85"></i>
                            </span>
                              </div>
                              <input name="email" minlength="3"
                                     autocomplete="work email"
                                     data-vv-validate-on="none" v-model="form.email" required type="email" :placeholder="'Enter email' | translate"
                                     v-validate="'required|email'" :class="{'input': true, 'form-control-danger': errors.any() }"
                                     class="form-control input-no-border">
                              <small class="text-danger" v-if="errors.has('email')">
                                {{ errors.first('email') }}
                              </small>
                              <div class="text-danger invalid-feedback mt-2" style="display: block;" v-for="e in errorsMessages.email">
                                {{ e }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="nc-icon nc-key-25"></i>
                            </span>
                          </div>
                          <input name="password" minlength="3" autocomplete="section-registration new-password" data-vv-validate-on="none" ref="password" v-model="form.password1" required type="password" :placeholder="'Enter password' | translate"
                                 v-validate="'required'" :class="{'input': true, 'form-control-danger': errors.any() }"
                                 class="form-control input-no-border">
                          <small class="text-danger" v-if="errors.has('password')">
                            {{ errors.first('password') }}
                          </small>
                          <div class="text-danger invalid-feedback mt-2" style="display: block;" v-for="e in errorsMessages.password1">
                            {{ e }}
                          </div>
                        </div>
                        <div class="form-group input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="nc-icon nc-key-25"></i>
                            </span>
                          </div>
                          <input name="confirmPassword" minlength="3" autocomplete="section-registration new-password" data-vv-validate-on="none" v-model="form.password2" required type="password" :placeholder="'Enter password again' | translate"
                                  :class="{'input': true, 'form-control-danger': errors.any() }"
                                 class="form-control input-no-border">
                          <div class="text-danger invalid-feedback mt-2" v-if="errors.has('confirmPassword')">
                            {{ errors.first('confirmPassword') }}
                          </div>
                          <div class="text-danger invalid-feedback mt-2" style="display: block;" v-for="e in errorsMessages.password2">
                            {{ e }}
                          </div>
                          <div class="text-danger invalid-feedback mt-2" style="display: block;" v-for="error in errorsMessages.nonFieldErrors">
                            {{ error }}
                          </div>
                        </div>
                      <p-button slot="footer" type="success" round block class="mb-3" :disabled="!(form.username && form.password1 && form.password2 && form.email)" v-loading="loading" native-type="submit"><translate>Register</translate></p-button>

                    </form>
                    <div class="forgot">
<!--                      <router-link v-if="invitation !== null" :to="{name: 'invitation-register', params: $route.params.key}" class="btn mb-3 btn-round btn-block btn-success" tag="a"><translate>Claim invite</translate></router-link>-->
                      <router-link to="/login" v-translate>
                        Login
                      </router-link>
                    </div>
                  </card>
              </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(/static/img/background/gmc1500.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Card, Checkbox, Button} from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.checkKey(to.params.key)
      })
    },
    beforeRouteUpdate (to, from, next) {
      this.checkKey(to.params.key)
      next()
    },
    created () {
      this.$validator.localize('ru')
    },
    methods: {
      validateBeforeSubmit (e) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.submit(e)
            return true
          }
        })
      },
      async submit (e) {
        e.preventDefault()
        this.errorsMessages = {
          nonFieldErrors: []
        }
        this.loading = true

        try {
          const result = await this.$http.post('user/register/', this.form)

          // Вход в аккаунт
          this.$auth.login({
            data: {
              username: this.form.username,
              password: this.form.password1
            },
            success: function () {
              this.loading = false
            },
            error: function (response) {
              this.loading = false
              if (undefined === response.response && response.message.toString() === 'Network Error') {
                this.errorsMessages.nonFieldErrors = [this.$gettext('Network error. Check internet connection')]
              } else {
                this.errorsMessages.nonFieldErrors = response.response.data.nonFieldErrors || []
                this.errorsMessages.username = response.response.data.username || []
                this.errorsMessages.password = response.response.data.password || []
              }
            },
            rememberMe: true,
            redirect: this.from ? this.from : '/',
            fetchUser: true
          })

        } catch (error) {
          this.loading = false
          window.err = error
          if (undefined === error.response && error.message.toString() === 'Network Error') {
            this.errorsMessages.nonFieldErrors = [this.$gettext('Network error. Check internet connection')]
          } else
          if (error.response.status === 400) {
            this.errorsMessages = error.response.data
          } else {
            debugger
            this.cleanErrors()
            this.errorsMessages.nonFieldErrors = [this.$gettext('Unknown error')]
          }
        }


      },
      cleanErrors () {
        this.errorsMessages.nonFieldErrors = []
      },
      async checkKey(key) {
        try {
          this.loading = true
          const result = await this.$http.get(`invitation/check/${key}/`)
          this.invitation = result.data
          this.form.email = this.invitation.email
          this.form.lastName = this.invitation.lastName
          this.form.firstName = this.invitation.firstName
          this.form.secondName = this.invitation.secondName
          this.$language.current = this.invitation.language
          this.loading = false
        } catch (e) {
          if (e.response && e.response.data && e.response.data.detail) {
            this.errorMessage = e.response.data.detail
          } else {
            this.errorMessage = e.message
          }
          this.loading = false

        }
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    data() {
      return {
        loading: false,
        errorMessage: null,
        invitation: null,
        errorsMessages: {
          nonFieldErrors: [],
        },
        form: {
          email: null,
          password1: null,
          password2: null,
          key: this.$route.params.key,
          username: null,
          lastName: null,
          firstName: null,
          secondName: null
        }
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style scoped>
  /*.col-md-4 {*/
  /*  padding-left: 3px;*/
  /*  padding-right: 3px;*/
  /*}*/
</style>
